module.exports = __webpack_public_path__ + "img/iconSystemProduct.b400c42c.svg";